<template>
  <div class="container-fluid payment-panel">
    <button class="payment-button" :style="saveColor" :disabled="disabled" @click="saveTable">
      SAVE
      <!-- 4 dp so server values like 306.1727 aren't truncated. The
           wire payload to processInvoice still carries 2 dp money. -->
      <span class="w-100">{{ $utils.formatCurrency((saleTotal - discount.total) / debtorCurrency.Rate, 4,``) }}</span>
    </button>
  </div>
</template>

<script>

export default {
  name: "PaymentControls",
  computed: {
    sale() {
      return this.$store.getters.getCurrentSale;
    },
    customer() {
      return this.$store.getters.getCustomer;
    },
    customerDetails() {
      return this.$store.getters.getDebtors.find(debtor => debtor.Id === this.customer);
    },
    discount() {
      return this.$store.getters.getSaleDiscount
    },
    saleTotal() {
      return this.$store.getters.getSaleTotal
    },
    debtorCurrency() {
      return this.$store.getters.getDebtorCurrency
    },
    disabled() {
      return this.$store.getters.getSaleUnits <= 0;
    },
    color() {
      return this.disabled ? {background: 'grey'} : {background: '#9ccc65'}
    },

    saveColor() {
      return this.disabled ? {background: 'grey'} : {background: '#475f9b'}
    }
  },
  methods: {
    saveTable() {
      let table = this.$store.getters.getTableBySaleNum(this.sale)
      if (table) {
        return this.editTable(table);
      } else {
        return this.createTable();
      }
    },
    loadPanel() {
      return Swal.fire({
        html: 'Updating table....',
        allowOutsideClick: false,
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading()
        },
      });
    },
    editTable(table) {
      this.loadPanel()
      let lines = this.$store.getters.getSaleLines;
      for (let i = 0; i < lines.length; i++) {
        let line = lines[i];
        // Line is a money value — round to 2 dp so the saved table
        // payload (which the server stores verbatim) doesn't carry
        // IEEE-754 noise like 0.48840500000000003.
        lines[i].Line = this.$utils.roundTo(Number(line.Qty) * Number(line.Unit), 2);
      }
      table.items = lines;
      table.Customer = this.$store.getters.getCustomer;
      table.name = table.Name;
      return this.$store.dispatch('updateTable', table)
          .then(() => responses.showInfo('Table successfully updated'))
          .finally(() => Swal.close())
    },
    createTable() {
      if (this.customerDetails) {
        return this.chooseAction(this.customerDetails);
      }
      return this.$router.push({name: 'select-customer'})
    },

    chooseAction(debtor) {
      return Swal.fire({
        icon: 'question',
        title: `Save Order<br><h6>Debtor : ${debtor.Name} ${debtor.Surname}</h6>`,
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        denyButtonColor: `rgb(88, 125, 224)`,
        preConfirm : () => {
          return this.quoteCustomer(debtor);
        },
      }).then((result) => {
        if (result.isConfirmed) {

        }
      })
    },

    quoteCustomer(debtor) {
      this.$utils.showLoading()
      this.$store.commit('setIsTabOpen', true)
      let input = `${debtor.Name}-${currentDate()}`;
      return this.$store.dispatch('saveNewTable', {
        name: input,
        Customer: debtor.Id,
      }).then((res) => {
        this.$store.commit('setIsTabOpen', false)
        return Swal.fire({
          icon: `success`,
          title: `Order Saved<br> <h6>Reference : ${input}</h6>`,
          showCancelButton: true,
          confirmButtonText: 'Download',
          showClass: {
            popup: 'animate__animated animate__fadeInDown'
          },
          cancelButtonText: 'Next Order',
        }).then((result) => {
          if (result.isConfirmed) {
            let quote = res.SaleNum;
            this.$store.dispatch(`downloadQuote`, quote);
          }
          return this.$router.push({name: 'pos'})
        })
      }).finally(() => this.$utils.hideLoading())
    },

    process() {
      this.$router.push({name: 'payment'})
    }
  }
}
</script>

<style lang="scss" scoped>
@media (max-width: 768px) {
  .view-order-button {
    opacity: 1 !important;
  }
}

.w-40 {
  border-radius: 10px;
}

.payment-panel {
  -webkit-box-shadow: 0 -2px 8px 0 rgba(203, 153, 126, 0.4);
  box-shadow: 0 -2px 8px 0 rgba(203, 153, 126, 0.4);
  display: flex;
  gap: 10px;
  flex-direction: row;
  padding: 10px;
  z-index: 1;
  background: white;

  .view-order-button {
    color: white;
    background: #40434A;
    font-size: 20px;
    font-weight: 700;
    font-family: 'Inter', sans-serif;
    border-radius: 10px;
    min-width: 140px;
    opacity: 0;
  }

  .payment-button {
    color: white;
    font-size: 20px;
    font-weight: 700;
    font-family: 'Inter', sans-serif;
    border-radius: 5px;
    height: 100%;
    width: 100%;
  }
}
</style>
